interface DeviceQuickActionCapability {
  getable?: boolean;
  id: string;
  setable?: boolean;
  type?: string;
}

interface DeviceQuickActionDevice {
  capabilitiesObj?: Record<string, DeviceQuickActionCapability | undefined> | null;
  settings?: {
    energy_alwayson?: unknown;
  } | null;
  ui?: {
    quickAction?: string | null;
    state?: string | null;
  } | null;
}

export function getDeviceTileStateCapabilityId(props: {
  device: DeviceQuickActionDevice | null | undefined;
}): string | null {
  const deviceUiState = props.device?.ui?.state;

  if (deviceUiState !== undefined) {
    return deviceUiState;
  }

  const defaultQuickActionId = props.device?.ui?.quickAction;

  if (typeof defaultQuickActionId !== 'string') {
    return null;
  }

  const capabilityObj = props.device?.capabilitiesObj?.[defaultQuickActionId] ?? null;

  if (capabilityObj?.getable !== true || capabilityObj.type !== 'boolean') {
    return null;
  }

  return defaultQuickActionId;
}

export function getIsDeviceQuickActionStateOnly(props: {
  capabilityObj: DeviceQuickActionCapability | null | undefined;
  device: DeviceQuickActionDevice | null | undefined;
}): boolean {
  if (props.capabilityObj == null) {
    return false;
  }

  if (
    props.capabilityObj.getable === true &&
    props.capabilityObj.setable !== true &&
    props.capabilityObj.type === 'boolean'
  ) {
    return true;
  }

  return getIsEnergyAlwaysOnOffCapability({
    capabilityObj: props.capabilityObj,
    device: props.device,
  });
}

export function getCanDisableDefaultDeviceQuickAction(props: {
  device: DeviceQuickActionDevice | null | undefined;
}): boolean {
  const defaultQuickActionId = props.device?.ui?.quickAction;

  if (typeof defaultQuickActionId !== 'string') {
    return false;
  }

  const capabilityObj = props.device?.capabilitiesObj?.[defaultQuickActionId] ?? null;

  if (capabilityObj == null) {
    return false;
  }

  if (capabilityObj.type !== 'boolean') {
    return false;
  }

  if (capabilityObj.setable !== true) {
    return false;
  }

  return (
    getIsDeviceQuickActionStateOnly({
      capabilityObj,
      device: props.device,
    }) !== true
  );
}

function getIsEnergyAlwaysOnOffCapability(props: {
  capabilityObj: DeviceQuickActionCapability;
  device: DeviceQuickActionDevice | null | undefined;
}): boolean {
  return props.capabilityObj.id === 'onoff' && props.device?.settings?.energy_alwayson === true;
}
